import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Image from '../components/image'

function AboutPage() {
    return (
        <Layout>
            <SEO
                keywords={[
                    `kevinlaminto`,
                    `kevin laminto`,
                    `kevin laminto photography`,
                    `kevin laminto aesthetic`,
                    `melbourne photographer`,
                    `melbourne fashion photographer`,
                ]}
                title='About'
            />
            <div className='grid grid-cols-1 gap-4 mb-20 max-w-lg kl:text-justify'>
                <Image imageName='me.jpg' />
                <p>
                    Kevin Laminto (b.1999) is a photographer and creative
                    director based in Melbourne, Australia. His works primarily
                    revolves around contemporary, fashion, lifestyle, and
                    portrait photography.
                </p>
                <p>
                    for inquiries, commissions, and questions, feel free to
                    email Kevin directly at:{' '}
                    <a href='mailto:kevin.laminto@gmail.com'>
                        kevin.laminto@gmail.com
                    </a>
                    .
                </p>
            </div>
        </Layout>
    )
}

export default AboutPage
